export const pdfContainerSx = {
  pdfMainBoxSx: {
    display: 'flex',
    gap: '12px',
    alignItems: 'stretch'
  },
  pdfCardsSx: {
    border: '1px solid grey',
    boxShadow: '0px 0.7px 5.58px 0px var(--color-shadow-card)',
    padding: '16px',
    borderRadius: '6px',
    backgroundColor: 'white',
    width: '100%'
    //height: '100%'
  },
  chipBoxSx: {
    width: '15rem',
    height: '36px',
    padding: '8px 12px 8px 12px',
    gap: '8px',
    borderRadius: '100px',
    backgroundColor: 'var(--color-bg-muted)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  chipTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 680,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-success-dark)'
  },
  iconStyle: {
    width: '26px',
    height: '26px'
  },
  circleProgressBoxSx: {
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    width: '170px', // Ensures both circles overlap
    height: '170px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  cardTitleStyles: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 680,
    color: 'var(--color-primary)'
  },
  graphDetailBoxSx: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'space-around',
    alignItems: 'center',
    height: '100%',
    marginTop: '8px'
  },
  graphTabBoxSx: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '15px',
    marginTop: '15px'
  },
  graphTitleTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-text-secondary)',
    marginBottom: '22px'
  },
  graphValueSx: {
    fontFamily: 'Inter',
    fontSize: '38px',
    fontWeight: 680,
    lineHeight: 'var(--line-height-28)',
    color: 'var(--color-primary)'
  },
  seoTasksTitleSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    color: 'var(--color-primary)',
    fontSize: 'var(--font-size-20)'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: '1.5rem',
    letterSpacing: '0em',
    color: 'var(--color-text-purple)',
    marginLeft: '0.625rem',
    //textDecoration: 'underline',
    cursor: 'pointer',
    //width: 'max-content',
    // zIndex: 100000000
  },
  titleSubBoxesSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  titleSubBoxesTextsSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: '10px',
    color: 'var(--color-text-purple)'
  },
  titleMainBoxSx: {
    marginTop: '16px',
    justifyContent: 'space-between'
  },
  titleSubTextsBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  graphValueBoxSx: {
    display: 'flex',
    gap: '4px',
    marginTop: '18px',
    justifyContent: 'center'
  },
  commonBoxMarginSx: {
    //marginBottom: '12px'
  },
  circleProgressMainBoxSx: {
    marginTop: '16px'
  },
  iconBoxMarginCss: {
    marginTop: '5px'
  },
  perSxFont: {
    fontSize: '16px !important'
  },
  commonImgIconStyle: {
    width: '16px',
    height: '16px'
  },
  gscTitleTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-14)',
    marginBottom: '16px',
    color: 'var(--color-primary)'
  },
  gscDescTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-purple)'
  },
  gscCardBoxSx: {
    minWidth: '40rem',
    padding: '30px'
  },
  compareDateBoxSx: {
    marginTop: '16px'
  },
  compareDateTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-purple)'
  },
  currentDateTextSx: {
    fontFamily: 'Inter',
    color: 'var(--color-text-purple)'
  },
  tableHeadText: {
    width: 'max-content',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-text-purple)'
  },
  dividerGraphSx: {
    '&.MuiDivider-vertical': {
      borderWidth: '2px !important'
    }
  },
  footerAlignBoxSx: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  drTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-purple)'
  },
  topicRowSx: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '5px 0',
    borderBottom: '1px solid rgba(224, 224, 224, 1)'
  },
  topicTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    color: 'var(--color-text-navy)',
    width: '85%',
    lineHeight: 'var(--line-height-20)'
  },
  topicChipTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    color: 'var(--color-text-navy)'
  }
};
export const pdfKeywordTrackingSx = {
  mainDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  keywordTracking: {
    fontFamily: 'Inter',
    fontWeight: 680,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-primary)'
  },
  dateSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: '10px',
    color: 'var(--color-text-purple)'
  },
  mainCardBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '32px',
    width: '100%'
  },
  cardBoxOne: {
    borderRadius: '4px',
    gap: '20px',
    padding: '24px',
    border: '1px solid grey',
    boxShadow: '0px 0.7px 5.58px 0px var(--color-shadow-card)'
  },
  cardTitle: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-18)',
    lineHeight: '10px',
    color: 'var(--color-text-secondary)'
  },
  cardValueText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-primary)'
  },
  cardValueBox: {
    marginTop: '19px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline'
  },
  cardChangeValue: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-18)',
    lineHeight: 'var(--line-height-14)'
  },
  iconStyle: {
    width: '16px',
    height: '16px'
  },
  iconBox: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '6px'
  },
  cardBox: {
    display: 'flex'
  },
  positionChangesSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)'
  },
  positionMainBox: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  listMainBox: {
    display: 'flex',
    gap: '30px'
  },
  listBoxSx: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  positionChangesBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginLeft: '10px'
  }
};
